// extracted by mini-css-extract-plugin
export default {"root":"WatermarkBackground_root__gQjr1"};